import { Card } from '@fluentui/react-components';
import type { CSSProperties, ReactNode } from 'react';

import { CustomScrollbar } from '@shared/components';

type TProps = {
  children: ReactNode;
  footer?: ReactNode;
  style?: CSSProperties;
};

const AiAssistantAnswerCard = ({ children, footer, style }: TProps) => (
  <Card className="!min-h-0 !mx-3 !mt-3 !p-0 !gap-0 !overflow-hidden flex flex-col" style={style}>
    <CustomScrollbar className="w-full overflow-x-hidden min-h-0 flex-1">
      <div className="pl-4 pr-4 py-4">{children}</div>
    </CustomScrollbar>
    {footer}
  </Card>
);

export default AiAssistantAnswerCard;
